// src/lib/site-link.ts: links back to the builder's own website (docs/onsite/ONSITE.md 6). For a confirmed member in a
// full session the link carries ?hb=1, the board hint the builder's site.js keeps (as a first-party flag, then strips
// from the address) to show "Sign In" in its desktop nav. Nobody else's links carry it.
import type { PublicTenant } from "../../shared/tenant";
import { me, site } from "../state/session";

export function siteHost(url: string): string {
  try {
    return new URL(url).host.replace(/^www\./, "");
  } catch {
    return url;
  }
}

/** The builder's site, with the board hint for a confirmed household member. */
export function siteHref(t: PublicTenant): string {
  // The test ride's "site" is homebuild.ai, which keeps no board hint.
  if (site.value?.trial) return t.contact.site;
  const u = me.value?.user;
  const hinted = !!u && u.verified && u.sessionStrength === "full" && !me.value?.staff;
  if (!hinted) return t.contact.site;
  try {
    const url = new URL(t.contact.site);
    url.searchParams.set("hb", "1");
    return url.href;
  } catch {
    return t.contact.site;
  }
}
